// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

const IMAGE_HEIGHT = 180;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CardWrapper = styled.div({
	display: 'grid',
	gridTemplateColumns: '100%',
	gridTemplateRows: '50% 50%',
	height: '100%',
	width: '80%',
	margin: '0 auto',
	overflowY: 'auto',
	justifyItems: 'center',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CardContent = styled.div({
	display: 'flex',
	alignItems: 'flex-start',
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CardText = styled.div({
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CardImage = styled.img({
	position: 'relative',
	height: `${IMAGE_HEIGHT}px`,
	objectFit: 'cover',
	userSelect: 'none',
});
